import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from "@quickenloans-ui-suite/components/atomics"

import DisclosureContent from './DisclosureContent';
import { defaultAttributes, testAttributes } from './Constants'
import { toolTipContainer, toolTipLabel } from './DisclosureTooltip.module.scss'

function DisclosureTooltip({ content, label = defaultAttributes.TARGET_TITLE }) 
{
    return (
        <div data-testid={testAttributes.DISCLOSURETOOLTIP_MAIN_CONTAINER} className={toolTipContainer}>
            <Tooltip 
                content={<DisclosureContent title={defaultAttributes.TARGET_TITLE}>{content}</DisclosureContent>}
                disableTouchListener
                placement="bottom"
                size="medium"
            >
                <span key="tooltip-disclosure" className={toolTipLabel}>{label}</span>
            </Tooltip>
        </div>
    )
}

DisclosureTooltip.propTypes = {
    /** content, Fast check content ( required ) */
    content: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.array,]).isRequired,
    /** label, Tooltip label */
    label: PropTypes.string,
};

export default DisclosureTooltip;